module.exports = __webpack_public_path__ + "static/media/vacationSchedule.d8978565.svg";